import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const toArray = (rows) => {
  if (!rows) {
    return [];
  }
  return Array.isArray(rows) ? rows : [rows];
};

const getNestedValue = (row, field) => {
  if (!row || !field) {
    return "";
  }
  if (!field.includes(".")) {
    return row[field];
  }
  return field.split(".").reduce((acc, key) => {
    if (acc == null) {
      return "";
    }
    return acc[key];
  }, row);
};

const getValueForColumn = (row, column) => {
  if (!column) {
    return "";
  }
  const baseValue = column.field ? getNestedValue(row, column.field) : "";
  let value = baseValue;

  if (typeof column.valueGetter === "function") {
    try {
      value = column.valueGetter({ data: row, colDef: column, value });
    } catch (err) {
      value = baseValue;
    }
  }

  if (typeof column.valueFormatter === "function") {
    try {
      value = column.valueFormatter({ value, data: row, colDef: column });
    } catch (err) {
      value = value ?? "";
    }
  }

  return value;
};

const buildSheetData = ({ rows, columns }) => {
  const normalizedRows = toArray(rows);
  const normalizedColumns =
    Array.isArray(columns) && columns.length
      ? columns
      : normalizedRows.length
      ? Object.keys(normalizedRows[0]).map((key) => ({
          headerName: key,
          field: key,
        }))
      : [];

  if (!normalizedColumns.length) {
    return [];
  }

  const headerRow = normalizedColumns.map(
    (column) => column.headerName || column.field || ""
  );

  const dataRows = normalizedRows.map((row) =>
    normalizedColumns.map((column) => getValueForColumn(row, column))
  );

  return [headerRow, ...dataRows];
};

export const exportRowsToExcel = ({ rows, columns, fileName, sheetName }) => {
  const sheetData = buildSheetData({ rows, columns });
  const safeName = fileName
    ? fileName.toLowerCase().endsWith(".xlsx")
      ? fileName
      : `${fileName}.xlsx`
    : "report.xlsx";

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || "Report");

  const workbookOut = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([workbookOut], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, safeName);
};
